import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../stores';
import { Layers, Modals } from '../stores/layers';
import { Modal } from '../components/Modal';
import { useTranslateFunction } from '../helpers/useTranslationHook';

export const NoFavouritesModal = observer(() => {
  const { t } = useTranslateFunction(Layers.favourites);
  const { layers } = useStore();

  const triggerModal = () => {
    layers.openLayer(Layers.favourites);
    layers.closeModal();
  };

  return (
    <Modal
      icon="icon-heart-empty"
      headline={t('no_favourites')}
      content={t('add_favourite_explanation')}
      className="no-scrollbar"
      isOpen={layers.activeModal === Modals.noFavourites}
      acceptAction={triggerModal}
      acceptText={t('button-ok')}
      abortAction={layers.closeModal}
      abortText={t('button-abort')}
    />
  );
});
